module.exports = __webpack_public_path__ + "static/media/arlet-app-screen1.74f10a92.png";